export const OpenMarketProductApprovalStatusConstant = {
  APPROVAL: 'APPROVAL',
  ONGOING: 'ONGOING',
  REJECT: 'REJECT',
} as const;

export const OpenMarketProductStatusConstant = {
  ONSALE: 'ONSALE',
  SOLDOUT: 'SOLDOUT',
} as const;

export type OpenMarketProductApporovalStatusType = keyof typeof OpenMarketProductApprovalStatusConstant;
export type OpenMarketProductStatusConstantType = keyof typeof OpenMarketProductStatusConstant;

export type WheelConditionLevel = '상' | '중' | '하';

export const WHEEL_CONDITION_OPTIONS: Record<string, WheelConditionLevel> = {
  High: '상',
  Medium: '중',
  Low: '하',
};
